import React from "react";
import {CubeCard} from '../../../components'
import localData from '../../../localData'

export default function Services() {
    const {code} = localData.svgs
    const {responsive,conversion,landingPage,dynamic,staticPage,ecomerce,developer} = localData.images

    return (
        <section className="services" id='services' data-lazy-block>
            <div className="container-fluid">
                <h2 className="services-title" data-lazy='fade'>services</h2>
                <h6 className="services-description">
                    These are some of the services I offer. Reach out to me if I can help you with any!
                </h6>
                <div className="services-center">
                    {
                      <>
                            <CubeCard className="card cube-card-primary" icon={responsive} title='responsive web design' />
                            <CubeCard className="card cube-card-primary" icon={conversion} title='PSD, Figma, XD to HTML' />
                            <CubeCard className="card cube-card-primary" icon={landingPage} title='landing page design' />
                            <CubeCard className="card cube-card-primary" icon={dynamic} title='dynamic website ' />
                            <CubeCard className="card cube-card-primary" icon={staticPage} title='static website' />
                            <CubeCard className="card cube-card-primary" icon={ecomerce} title='eCommerce website' />
                            <CubeCard className="card cube-card-primary" icon={developer} title='development' />
                      </>
                    }
                </div>
            </div>
        </section>
    );
}
